<script>
import options from './DitRaaderumCalculatorInputCard.options'

export default options
</script>

<template>
    <NykBasicCard class="nyk-dit-raaderum-calculator__calculate-card">
        <form @submit.prevent="$emit('calculate')">
            <div class="nyk-dit-raaderum-calculator__calculate-content">
                <NykInput
                    name="dit-raaderum-house-value"
                    type="text"
                    input-mode="numeric"
                    :format="numberInputFormat"
                    :emit-unmasked-value="true"
                    :predefined-value="houseValue"
                    :label="labels.houseValueLabel"
                    :clear-button-aria-label="labels.clearHouseValueAriaLabel"
                    prefix="kr."
                    background-color="var(--nds-color-surface-secondary-light)"
                    :required="true"
                    :validators="requiredValidators"
                    @input="$emit('update-house-value', $event)" />
                <NykInput
                    name="dit-raaderum-housing-debt"
                    type="text"
                    input-mode="numeric"
                    :format="numberInputFormat"
                    :emit-unmasked-value="true"
                    :predefined-value="remainingDebt"
                    :label="labels.housingDebtLabel"
                    :clear-button-aria-label="labels.clearHousingDebtAriaLabel"
                    prefix="kr."
                    background-color="var(--nds-color-surface-secondary-light)"
                    :required="true"
                    :validators="requiredValidators"
                    @input="$emit('update-remaining-debt', $event)" />
            </div>

            <div class="nyk-dit-raaderum-calculator__calculate-actions">
                <NykButton type="submit" variant="filled-primary" :disabled="isLoading">
                    {{ labels.calculateButton }}
                </NykButton>

                <a :href="`#${legalLabels.anchorId}`" class="nyk-button nyk-button--link">
                    {{ legalLabels.legalLabel }}
                    <div class="nyk-button__icon">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 12">
                            <path
                                fill="var(--colortheme-icon)"
                                d="M0 5.393v1.231h11.37l-3.898 4.243.67.633L14 5.991 8.142.5l-.67.633 3.898 4.26H0Z"></path>
                        </svg>
                    </div>
                </a>
            </div>
        </form>
    </NykBasicCard>
</template>
